<script>
import FontIcon from 'dashboard/components-next/icon/FontIcon.vue';

const DIRECTIONAL_ICONS = {
  'chevron-left': 'chevron-left',
  'chevron-right': 'chevron-right',
  'chevron-up': 'chevron-up',
  'chevron-down': 'chevron-down',
  'arrow-left': 'chevron-left',
  'arrow-right': 'chevron-right',
  'arrow-up': 'chevron-up',
  'arrow-down': 'chevron-down',
};

export default {
  components: { FontIcon },
  props: {
    icon: {
      type: String,
      required: true,
    },
    icons: {
      type: Object,
      required: true,
    },
    size: {
      type: [String, Number],
      default: '20',
    },
    type: {
      type: String,
      default: 'outline',
    },
    viewBox: {
      type: String,
      default: '0 0 24 24',
    },
    iconLib: {
      type: String,
      default: 'fluent',
    },
  },

  computed: {
    fontIcon() {
      if (this.icon === 'arrow-clockwise') {
        return this.type === 'solid' ? 'refresh-filled' : 'refresh-outline';
      }
      if (this.icon === 'delete') {
        return this.type === 'solid' ? 'delete-filled' : 'delete-outline';
      }
      if (this.icon === 'edit') {
        return this.type === 'solid'
          ? 'pencil-edit-filled'
          : 'pencil-edit-outline';
      }
      return DIRECTIONAL_ICONS[this.icon];
    },
    pathSource() {
      // To support icons with multiple paths
      const path = this.icons[`${this.icon}-${this.type}`];
      if (path.constructor === Array) {
        return path;
      }
      return [path];
    },
  },
};
</script>

<template>
  <FontIcon
    v-if="fontIcon"
    :icon="fontIcon"
    :size="Number(size)"
    class="leading-none"
  />
  <svg
    v-else-if="iconLib === 'fluent'"
    :width="size"
    :height="size"
    fill="none"
    :viewBox="viewBox"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      v-for="source in pathSource"
      :key="source"
      :d="source"
      fill="currentColor"
    />
  </svg>
  <svg
    v-else
    :width="size"
    :height="size"
    fill="none"
    :viewBox="viewBox"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g v-for="(pathData, index) in pathSource" :key="index">
      <path
        :key="pathData"
        :d="pathData"
        stroke="currentColor"
        stroke-width="1.66667"
      />
    </g>
  </svg>
</template>
